import { computed } from 'vue'

import type { ComputedRef } from 'vue'
import type { LinkTextPrimaryMediumProps } from '../types/interfaces'

interface UseLinkTextPrimaryMediumOptions {
  props: LinkTextPrimaryMediumProps
}

interface UseLinkTextPrimaryMediumReturn {
  refIsBlankTarget: ComputedRef<boolean>
}

export const useLinkTextPrimaryMedium = ({ props }: UseLinkTextPrimaryMediumOptions): UseLinkTextPrimaryMediumReturn => {
  const refIsBlankTarget = computed<boolean>(() => props.target === '_blank')

  return {
    refIsBlankTarget,
  }
}
